import { mapActionsFromConfigurations } from '../../helpers/action';
import { configurations } from './configurations';
import { apiAction as get } from './configurations/get';

export const apiActions = {
  publishers: {
    get
  }
}

const actions = mapActionsFromConfigurations('publishers')(configurations);

export * from './configurations/endpoints';

export default actions;


// WEBPACK FOOTER //
// ./src/state/modules/publisher/actions.js